// start:ng42.barrel
export * from './cancel-conf.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/cancel-conf/cancel-conf/index.ts